<template>
    <div class="App">
        <router-view v-if="loaded"></router-view>
        <BaseLoader v-else />
        <DateTimePicker v-if="dateTimePickerVisible" />
        <TheConfirmation v-if="confirmationVisible"></TheConfirmation>
        <GlobalErrors />
        <GlobalMessages />
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    import DateTimePicker from './components/common/dateTimePicker/DateTimePicker.vue';
    import TheConfirmation from './components/common/TheConfirmation.vue';
    import GlobalErrors from './components/common/GlobalErrors.vue';
    import GlobalMessages from './components/common/GlobalMessages.vue';
    import BaseLoader from './components/common/BaseLoader.vue';

    export default {
        name: 'app',
        components: {
            DateTimePicker,
            TheConfirmation,
            GlobalErrors,
            GlobalMessages,
            BaseLoader
        },
        computed: {
            ...mapState({
                loaded: s => s.settings.loaded,
                dateTimePickerVisible: s => s.dateTimePicker.visible,
                confirmationVisible: s => s.confirmation.visible
            })
        }
    };
</script>

<style>
    body {
        margin: 0;
    }

    .App {
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin: auto;
        min-height: 100vh;
        background: #b0bec5;
        background: radial-gradient(ellipse at center, #eceff1 0, #90a4ae 100%);
    }
</style>




// WEBPACK FOOTER //
// App.vue?37736545